module.exports = __webpack_public_path__ + "img/lotto-dl-ladl-800x228.eb40a0e6.jpg";